import { combineReducers } from 'redux';

import typeId from './typeId';
import regTypeId from './regTypeId';
import colors from './colors';
import activeBuilderType from './activeBuilderType';
import alert from './alert';
import inputWithProps from './inputWithProps';
import bgImage from './bg-image';


export default combineReducers({
    typeId,
    regTypeId,
    colors,
    activeBuilderType,
    alert,
    inputWithProps,
    bgImage
});
